<template>
  <div>
    <Panel label="Protokollarten">
      <div style="position: relative">
	<PanelBlock>
	  <p class="control">
	    <b-input
	      v-model="filterValue"
	      type="search"
	      icon="search"
	      expanded
	    >
	    </b-input>
	  </p>
	</PanelBlock>
	<PanelBlock v-for="item in filteredItems" :key="item.id">
	  <b-field>
	    <template #label>
	      <b-checkbox
		:value="item.selected"
		@input="handleInput(item.id, $event)"
	      >
		{{ item.label }} ({{ item.count }})
	      </b-checkbox>
	    </template>
	  </b-field>
	</PanelBlock>
	<!-- show selected items if no matches -->
	<PanelBlock v-for="item in extraItems" :key="item.id">
	  <b-field>
	    <template #label>
	      <b-checkbox
		:value="item.selected"
		@input="handleInput(item.id, $event)"
	      >
		{{ item.label }} (0)
	      </b-checkbox>
	    </template>
	  </b-field>
	</PanelBlock>
	<b-loading :active="loading" :is-full-page="false"></b-loading>
      </div>
    </Panel>
  </div>
</template>

<script>
 import Panel from '@/components/Panel.vue'
 import PanelBlock from '@/components/PanelBlock.vue'

 export default {
   components: {
     Panel,
     PanelBlock
   },
   model: {
     prop: 'selected',
     event: 'input'
   },
   props: {
     items: {
       type: Array,
       default: () => []
     },
     selected: {
       type: Array,
       default: () => []
     },
     loading: {
       type: Boolean,
       default: false
     }
   },
   data() {
     return {
       filterValue: ''
     }
   },
   watch: {
     items() {
       if (this.filterValue !== '') {
	 this.filterValue = ''
       }
     }
   },
   computed: {
     isEmpty() {
       return this.items.length === 0
     },
     filteredItems() {
       return this.items.filter(
	 (item) => item.name.toLowerCase().indexOf(this.filterValue.toLowerCase()) !== -1
       )
     },
   },
   methods: {
     handleInput(id, value) {
       const selected = this.selected.slice()

       // only allow single item to be selected
       if (value === true) {
	 if (!selected.includes(id)) {
	   selected.splice(0)
	   selected.push(id)
	 }
       }
       else if (selected.includes(id)) {
	 selected.splice(selected.indexOf(id), 1)
       }
       this.$emit('input', selected)
     }
   }
 }
</script>
